import(/* webpackMode: "eager" */ "/home/runner/work/tipsy-ui/tipsy-ui/app/[lang]/@desktop/(app)/_components/DesktopAppLayout.tsx");
